import {
  Router,
  Route,
  Navigate,
  useParams,
  useNavigate,
} from "@solidjs/router";
import { Toaster } from "solid-toast";

import { AuthProvider } from "./contexts/AuthContext";
import { ProfileProvider, RequireProfile } from "./contexts/ProfileContext";
import ProfileSelectPage from "./pages/ProfileSelectPage";
import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/LoginPage";
import SessionsPage from "./pages/SessionsPage";
import InterviewSessionPage from "./pages/InterviewSessionPage";
import SessionSetup from "./pages/SessionSetup";
import PopoutTranscript from "./pages/PopoutTranscript";
import GuestJoin from "./pages/GuestPage";
import AdminQuestionsPage from "./pages/AdminQuestionsPage";

const SessionsPageRoute = () => (
  <ProtectedRoute>
    <SessionsPage />
  </ProtectedRoute>
);

const SessionSetupRoute = () => {
  const params = useParams();
  return (
    <ProtectedRoute>
      <SessionSetup />
    </ProtectedRoute>
  );
};

const SessionRoute = () => {
  const params = useParams();
  const navigate = useNavigate();
  return (
    <ProtectedRoute>
      <InterviewSessionPage
        sessionId={params.id}
        isNewSession={false}
        onNavigateBack={() => navigate("/sessions")}
      />
    </ProtectedRoute>
  );
};

const AdminQuestionsRoute = () => (
  <ProtectedRoute>
    <AdminQuestionsPage />
  </ProtectedRoute>
);

const App = () => (
  <ProfileProvider>
    <RequireProfile fallback={<ProfileSelectPage />}>
      <AuthProvider>
        <Router>
          {/* Login page */}
          <Route path="/login" component={LoginPage} />

          {/* Admin routes */}
          <Route path="/admin/questions" component={AdminQuestionsRoute} />

          {/* Protected routes */}
          <Route path="/sessions" component={SessionsPageRoute} />

          {/* New Setup Route */}
          <Route path="/sessions/new/:id/setup" component={SessionSetupRoute} />

          {/* Existing Session Route */}
          <Route path="/sessions/:id" component={SessionRoute} />

          {/* Pop-out transcript routes */}
          <Route
            path="/sessions/:id/popout/:role"
            component={() => (
              <ProtectedRoute>
                <PopoutTranscript />
              </ProtectedRoute>
            )}
          />
          <Route path="/join/:id" component={GuestJoin} />

          {/* Default redirect */}
          <Route path="/" component={() => <Navigate href="/sessions" />} />
        </Router>

        <Toaster />
      </AuthProvider>
    </RequireProfile>
  </ProfileProvider>
);

export default App;
